import Lottie from 'lottie-react';
import LottieLoading from '@/assets/LottieLoading.json';
import NewAnalysisForm from './NewAnalysisForm';

type NoAnalysisDataProps = {
  showForm?: boolean;
};

const NoAnalysisData = ({ showForm = true }: NoAnalysisDataProps) => {
  return (
    <div className="d-flex flex-column gap-3 justify-content-center align-items-center">
      {showForm && <NewAnalysisForm />}
      <div
        className="mb-3 text-center"
        style={{ width: '250px', margin: 'auto' }}
      >
        <Lottie animationData={LottieLoading} />
      </div>
      <div className="mt-6 fw-medium text-center">
        برای شروع بررسی، نشانی کامل رو وارد کن و دکمه بررسی رو بزن.
      </div>
    </div>
  );
};

export default NoAnalysisData;
